/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CollectionsModule
 */

import { Collection } from 'ajs/modules/data-model/factories/collection.factory';
import { AvailabilityZoneItem } from 'items/availability-zone.item.factory';

/**
 * @description AvailabilityZone collection.
 * @author Sarthak Kapoor
 */

export class AvailabilityZoneCollection extends Collection {
    protected static ngDependencies = [AvailabilityZoneItem];

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'availabilityzone',
            windowElement: 'lazy-load',
            ...args,
        };

        super(extendedArgs);

        this.itemClass_ = this.getNgDependency(AvailabilityZoneItem);
    }
}
